<template>
	<section class="widget text" v-if="text">
		<h2 v-if="text.title.lenght > 0">{{text.title}}</h2>
		<div v-html="text.content"></div>
	</section>
</template>
<script>
export default {
	name: 'textWidget',
	props: ['data'],
	computed: {
		text(){
			return this.data
		}
	},
	data() {
		return {

		}
	},
	methods: {

	}
}

</script>